import {getHomeRoute} from '@cohort/merchants/lib/Pages';

const useDefaultRoute = (): string => {
  return getHomeRoute().path;
};

export default useDefaultRoute;
